import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10ab4451"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "img_list" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "img_item_wrap_del"
}
const _hoisted_4 = { class: "mod_btn iiwd_btn" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-hint" }, "建议上传尺寸800*n,图片小于2M,支持JPG,PNG,GIF", -1))

import { ref, watch, unref, reactive } from 'vue';
import { DragOutlined, DeleteOutlined } from '@ant-design/icons-vue';
import { VueDraggableNext } from 'vue-draggable-next';
import { cropper } from 'vue-picture-cropper';
import CUploadCropper from '@/components/CUploadCropper.vue';
import { dragDrop } from '@/utils/format/dragDrop';
import http from '@/api';
interface IProps {
  modelValue: string[];
}
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}

interface Result {
  dataURL: string;
  blobURL: string;
}

const __default__ = { name: 'customMenuImage' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: string[];
};

const draggable = VueDraggableNext;

const form = ref<string[]>([]);
form.value = unref(props.modelValue);

watch(form, (newVal) => {
  emit('update:modelValue', newVal);
});

const onRemoveImg = (index: number) => {
  form.value.splice(index, 1);
};

//视频列表拖拽事件
const dragOptions = ref({
  animation: 200,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
});
// upload module

const fileList = ref<any>([]);
const selectUrl = ref();
const beforeUpload = (file: FileItem) => {
  // if (fileList.value.length === 1) {
  //   const index = fileList.value.indexOf(file);
  //   const newFileList = fileList.value.slice();
  //   newFileList.splice(index, 1);
  //   fileList.value = newFileList;
  // }
  fileList.value = [...fileList.value, file];
  selectUrl.value = fileList.value.map((e: any) => {
    return window.URL.createObjectURL(e);
  });
  pic.value = window.URL.createObjectURL(fileList.value[0]);
  isShowDialog.value = true;
  return false;
};

const beforeUploads = (file: FileItem) => {
  fileList.value = [...fileList.value, file];
  selectUrl.value = fileList.value.map((e: any) => {
    return window.URL.createObjectURL(e);
  });
  // selectUrl.value = selectUrl.value.concat(arr);
  return false;
};

const isShowDialog = ref<boolean>(false);
const pic = ref<string>('');
const result: Result = reactive({
  dataURL: '',
  blobURL: '',
});
/**
 * 获取裁切结果
 */
const getResult = async (): Promise<void> => {
  // console.log(cropper)
  // 获取生成的base64图片地址
  const base64: string = cropper.getDataURL();
  // 获取生成的blob文件信息
  const blob: Blob = await cropper.getBlob();
  // 获取生成的file文件信息
  const file = await cropper.getFile({
    fileName: '测试文件名，可不传',
  });
  const refile = new File([blob], fileList.value[indexOf.value].name, { type: blob.type });
  // 把base64赋给结果展示区
  result.dataURL = base64;
  // handleUpload(refile);
  try {
    result.blobURL = URL.createObjectURL(blob);
    selectUrl.value[indexOf.value] = result.blobURL;
    pic.value = result.blobURL;
    fileList.value[indexOf.value] = refile;
  } catch (e) {
    result.blobURL = '';
  }
  // 隐藏裁切弹窗
};
const indexOf = ref(0);
const getIndex = (index: number) => {
  indexOf.value = index;
};

const confirmLoading = ref(false);
const determine = async () => {
  try {
    confirmLoading.value = true;
    for (let i = 0; i < fileList.value.length; i++) {
      const formData = new FormData();
      const refile = new File([fileList.value[i]], fileList.value[i].name, { type: fileList.value[i].type });
      formData.append('images', refile as any);
      await http.liveExpress
        .upImages(formData)
        .then((res) => {
          form.value.push(res.data.data.url);
        })
        .catch((err) => {
          // message.error('上传失败');
        });
    }
  } finally {
    cancelChange();
    confirmLoading.value = false;
  }
};

// 取消
const cancelChange = () => {
  fileList.value = [];
  isShowDialog.value = false;
};

// 删除
const changeDel = (index: number) => {
  selectUrl.value.splice(index, 1);
  fileList.value.splice(index, 1);
  pic.value = selectUrl.value[0];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(draggable), _mergeProps({ list: form.value }, dragOptions.value, {
        handle: ".mover",
        options: { animation: 500 },
        onDrop: _unref(dragDrop)
      }), {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "img_item_wrap"
            }, [
              _createElementVNode("img", {
                src: item,
                class: "img_item",
                alt: "avatar"
              }, null, 8, _hoisted_2),
              item
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(DragOutlined), { class: "mod_btn_icon mover" }),
                      _createVNode(_unref(DeleteOutlined), {
                        class: "mod_btn_icon",
                        onClick: _withModifiers(($event: any) => (onRemoveImg(index)), ["stop"])
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _: 1
      }, 16, ["list", "onDrop"])
    ]),
    _createVNode(CUploadCropper, {
      "file-list": fileList.value,
      "before-upload": beforeUpload,
      "is-show-dialog": isShowDialog.value,
      "cancel-change": cancelChange,
      "get-result-change": getResult,
      pic: pic.value,
      multiple: true,
      "select-url": selectUrl.value,
      "before-uploads": beforeUploads,
      determine: determine,
      "onClick:index": getIndex,
      "onClick:del": changeDel,
      "confirm-loading": confirmLoading.value
    }, {
      uploadImg: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["file-list", "is-show-dialog", "pic", "select-url", "confirm-loading"])
  ]))
}
}

})